import React from "react"
import { inject, observer } from "mobx-react"
import { Row, Col } from "react-styled-flexboxgrid"

import DOB from "./DOB"
import PlateNumber from "./PlateNumber"
import LicenseState from "./LicenseState"
import TABLE_SIZES from "../Grid/outterTableSizesRow"

@inject((all) => ({
  isMobile: all.store.ui.isMobile,
}))
@observer
class DOBPlateNumberAndLicenseState extends React.Component {
  render() {
    return (
      <Row>
        <Col {...TABLE_SIZES.inputColumn}>
          <DOB />
        </Col>
        <Col {...TABLE_SIZES.inputColumn}>
          <PlateNumber />
        </Col>
        <Col {...TABLE_SIZES.inputColumn}>
          <LicenseState />
        </Col>
      </Row>
    )
  }
}

export default DOBPlateNumberAndLicenseState

